module.exports = "<div>\r\n    <p class=\"font-weight-bold\">\r\n        * Champs obligatoires\r\n    </p>\r\n</div>\r\n"